module.exports = __webpack_public_path__ + "img/Icon_Delete.2d55d127.svg";